export default __webpack_public_path__ + "static/media/GH.426eede3.ico";